import { render, staticRenderFns } from "./TxHistoryChart.vue?vue&type=template&id=18f001fd"
import script from "./TxHistoryChart.vue?vue&type=script&lang=js"
export * from "./TxHistoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports